import { either } from "sanctuary";

export const eitherSanctuary = ({ val, fail, pass }) => either(fail, pass)(val);
